import { createSelector } from 'reselect';

import { OUTFIT_CATEGORIES } from 'components/Possessions/constants';

const getIsExpanded = ({ outfit: { isExpanded } }) => isExpanded;

const inputFuncs = [getIsExpanded];

const outputFunc = (isExpanded) => {
  const slotNames = isExpanded ? OUTFIT_CATEGORIES.Expanded : OUTFIT_CATEGORIES.Standard;
  return slotNames.map(name => ({
    name,
  }));
};

export default createSelector(inputFuncs, outputFunc);